// extracted by mini-css-extract-plugin
module.exports = {"button":"CollapseButton_button__K00Vf"};